import { SyncLoader } from 'react-spinners';

const Loading = () => {
    return (
        <div className="loading-container">
            <SyncLoader color="#a8a8a8" size={10} />
        </div>
    )
}

export default Loading;